// extracted by mini-css-extract-plugin
export default {"widget":"contacts_widget__q3vtG","label":"contacts_label__14YXf","subtitle":"contacts_subtitle__HhciI","total":"contacts_total__jxBj7","smallStats":"contacts_smallStats__Ne6GI"};